<template>
  <template v-if="hint">
    <slide-up-down-fi
      :model-value="!isCollapsed"
      :duration="300"
    >
      <div
        :class="{
          'quantity-modification-hint-fi': true,
          [`quantity-modification-hint-fi--active`]: !isCollapsed,
          [`quantity-modification-hint-fi--theme-${theme}`]: theme.length,
        }"
        data-test="modification-hint"
        :data-test-2="dataTest2"
      >
        <icon-fi
          class="quantity-modification-hint-fi__icon"
          :icon="icon"
        />
        {{ hint }}
        <icon-fi
          v-if="!persistent"
          class="quantity-modification-hint-fi__icon-close"
          icon="close"
          @click="isCollapsed = true"
        />
      </div>
    </slide-up-down-fi>
  </template>
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref } from 'vue';

import IconFi from '@/components/atoms/icon-fi/IconFi.vue';
import SlideUpDownFi from '@/components/atoms/slide-up-down-fi/SlideUpDownFi.vue';

interface Props {
  hint?: string;
  icon?: string;
  theme?: string;
  dataTest2?: string | null;
  persistent?: boolean;
}

withDefaults(defineProps<Props>(), {
  hint: '',
  icon: 'info',
  theme: '',
  dataTest2: null,
  persistent: false,
});

const isCollapsed = ref(true);

onMounted(async () => {
  await nextTick();
  isCollapsed.value = false;
});
</script>

<style scoped src="./quantity-modification-hint-fi" />
